import {
    AssignmentSourceSystem,
    InstructionHubFlags,
    InstructionHubState
} from './instruction-hub.types';
import {
    TransformedStudentAssignment
} from '@services/gateways/classroom-report-gateway/classroom-report-gateway.types';
import {
    CombinedAssignAssignmentDefaultParams
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

export type CombinedAssignInstructionHubRecord = Pick<CombinedAssignAssignmentDefaultParams,
    'isInstructionHubAssignment' |
    'currentAssignmentId' |
    'currentAssignmentSourceSystem' |
    'resultAccuracy'
>;

/**
 * Placeholder for potential Instruction Hub deep linking in the future.
 * The final destination and id format are not confirmed yet.
 */
export function getInstructionHubManageUrl ({
    baseUrl = ''
}: { baseUrl?: string } = {}) {
    return baseUrl;
}

// A missing value stays editable, so a response without a source blocks nothing.
export function isInstructionHubSourceSystem (sourceSystem: AssignmentSourceSystem | null | undefined) {
    return Number.isInteger(sourceSystem) && sourceSystem !== AssignmentSourceSystem.Api;
}

export function getActivitiesInstructionHubState (
    studentAssignment: Pick<TransformedStudentAssignment, 'assignment' | 'result'> | null
): InstructionHubState {
    return {
        isInstructionHubAssignment: studentAssignment?.assignment?.isInstructionHubAssignment === true ||
            isInstructionHubSourceSystem(studentAssignment?.assignment?.sourceSystem),
        isInstructionHubResult: studentAssignment?.result?.score != null &&
            studentAssignment.result.isInstructionHubAssignment === true
    };
}

export function getCombinedAssignInstructionHubState (
    record: CombinedAssignInstructionHubRecord | null
): InstructionHubState {
    const isInstructionHubRecord = record?.isInstructionHubAssignment === true;
    // Results stay on the testing flag until the API returns a result source.
    const isInstructionHubCurrentAssignment = isInstructionHubRecord ||
        isInstructionHubSourceSystem(record?.currentAssignmentSourceSystem);

    return {
        isInstructionHubAssignment: isInstructionHubCurrentAssignment && record?.currentAssignmentId != null,
        isInstructionHubResult: isInstructionHubRecord && record.resultAccuracy != null
    };
}

export function getEnabledInstructionHubState (
    {
        isInstructionHubAssignment,
        isInstructionHubResult
    }: InstructionHubState,
    {
        isInstructionHubEnabled,
        isInstructionHubResultsEnabled
    }: InstructionHubFlags
): InstructionHubState {
    return {
        isInstructionHubAssignment: isInstructionHubEnabled && isInstructionHubAssignment,
        isInstructionHubResult: isInstructionHubEnabled && isInstructionHubResultsEnabled && isInstructionHubResult
    };
}

export function isInstructionHubBlocked (
    instructionHubState: InstructionHubState,
    instructionHubFlags: InstructionHubFlags
) {
    const {
        isInstructionHubAssignment,
        isInstructionHubResult
    } = getEnabledInstructionHubState(instructionHubState, instructionHubFlags);

    return isInstructionHubAssignment || isInstructionHubResult;
}
